
import { useState, useEffect } from "react";
import WorkspaceService from "services/workspace-service";
import ProfileService from "services/profile-service";
import { fetchReportData } from "utils/fetchReportData";

// Accept the selected date range as a parameter
export const useFetchProfiles = (selectedDateRange) => {
  const [currentData, setCurrentData] = useState([]);
  const [previousData, setPreviousData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // console.log("Incoming Days selected : ", selectedDateRange);

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        // Determine the date ranges dynamically
        const today = new Date();
        let startDate, prevStart, prevEnd;

        if (selectedDateRange === "last7Days") {
          startDate = new Date();
          startDate.setDate(today.getDate() - 7); // Start of the current 7-day range

          // Set `prevEnd` as the end of the previous 7-day range
          prevEnd = new Date(startDate);
          prevEnd.setDate(startDate.getDate() - 1); // End of the previous range

          // Set `prevStart` as the start of the previous 7-day range
          prevStart = new Date(prevEnd);
          prevStart.setDate(prevEnd.getDate() - 6); // Start of the previous range
        } else {
          // Default to "last30Days"
          startDate = new Date();
          startDate.setDate(today.getDate() - 30); // Start of the current 30-day range

          // Set `prevEnd` as the end of the previous 30-day range
          prevEnd = new Date(startDate);
          prevEnd.setDate(startDate.getDate() - 1); // End of the previous range

          // Set `prevStart` as the start of the previous 30-day range
          prevStart = new Date(prevEnd);
          prevStart.setDate(prevEnd.getDate() - 29); // Start of the previous range
        }


        const workspaceProfiles = await WorkspaceService.fetchWorkspaceProfiles();
        const filteredProfiles = workspaceProfiles
          .filter((profile) => profile.own === true)
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));


        const formattedProfiles = await Promise.all(
          filteredProfiles.map(async (profile) => {
            const details = await ProfileService.fetchProfile(profile.platform, [], profile.id);
            console.log("Dashboard Own Profile details : ", details);
            return {
              id: profile.id,
              platform: profile.platform,
              name: details.name || "",
              profilePictureUrl: details.profilePictureUrl || "",
              verifiedStatus: details.verifiedStatus || false,
              link: details.link,
              data: details.data || [],
            };
          })
        );

        // Fetch both current and previous datasets
        const currentReportData = await fetchReportData(formattedProfiles, startDate, today);
        const previousReportData = await fetchReportData(formattedProfiles, prevStart, prevEnd);

        // console.log("Current Report Data : ", currentReportData);
        // console.log("Previous Report Data : ", previousReportData);
        setCurrentData(currentReportData);
        setPreviousData(previousReportData); // Store previous data in state
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, [selectedDateRange]); // Rerun the effect whenever the selectedDateRange changes

  return { currentData, previousData, loading, error };
};
